/* ==========================================================================
   HUMO BARRILES USA · PREVENTA EN 3 PASOS
   assets/humo-preventa.js

   Paso 1: el cliente elige el barril (deslizando, con flechas o con los
   botones de talla) y lo agrega con su cantidad. El paso se cierra y abre
   el 2. Paso 2: accesorios opcionales, con la meta de 3 accesorios. Paso 3:
   el carrito, que solo aparece aquí. Antes de pagar aparece la oferta
   especial (ver reglas abajo). Todo usa el carrito real de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-pv]');
  if (!raiz) return;

  var LENTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BARRILES = JSON.parse(raiz.querySelector('[data-pv-barriles]').textContent || '[]');
  var IDS_BARRIL = BARRILES.map(function (b) { return b.vid; });

  var TX = {
    es: {
      elegir: function (c) { return 'ELEGIR BARRIL ' + c; }, agotado: 'AGOTADO',
      ahorras: 'AHORRAS ', agregar: 'AGREGAR', agregado: 'AGREGADO', enCarrito: function (n) { return 'AGREGADO (' + n + ')'; },
      sinAcc: 'Sin accesorios', acc: function (n) { return n === 1 ? '1 accesorio' : n + ' accesorios'; },
      vacio: 'Tu carrito está vacío. Elige un barril para empezar.',
      quitar: 'Quitar', cargando: 'Cargando…', error: 'No pudimos cargar este producto.',
      aviso: function (t) { return 'Tu precio de preventa termina en ' + t; },
      okBarril: 'Barril agregado a tu preventa.', okAcc: 'Accesorio agregado.', fin: 'LA PREVENTA TERMINÓ',
      quedan: function (n) { return n === 1 ? '¡Queda <b>1 unidad</b>, aprovecha ahora!' : 'Quedan <b>' + n + ' unidades</b> restantes, ¡aprovecha ahora!'; },
      aplicando: 'Aplicando…', agregarCarrito: 'AGREGAR A MI PREVENTA',
      meta: [
        'Agrega <b>3 accesorios</b> y completa la meta.',
        '¡Vas bien! Te faltan <b>2 accesorios</b>.',
        '¡Casi! Te falta <b>1 accesorio</b>.',
        '<b>¡META CUMPLIDA!</b> Gracias por ayudarnos a recuperar lo nuestro.'
      ]
    },
    en: {
      elegir: function (c) { return 'SELECT ' + c + ' BARREL'; }, agotado: 'SOLD OUT',
      ahorras: 'YOU SAVE ', agregar: 'ADD', agregado: 'ADDED', enCarrito: function (n) { return 'ADDED (' + n + ')'; },
      sinAcc: 'No accessories', acc: function (n) { return n === 1 ? '1 accessory' : n + ' accessories'; },
      vacio: 'Your cart is empty. Pick a barrel to start.',
      quitar: 'Remove', cargando: 'Loading…', error: 'Could not load this product.',
      aviso: function (t) { return 'Your pre-sale price ends in ' + t; },
      okBarril: 'Barrel added to your pre-order.', okAcc: 'Accessory added.', fin: 'THE PRE-SALE HAS ENDED',
      quedan: function (n) { return n === 1 ? 'Only <b>1 unit</b> left, grab it now!' : 'Only <b>' + n + ' units</b> left, grab yours now!'; },
      aplicando: 'Applying…', agregarCarrito: 'ADD TO MY PRE-ORDER',
      meta: [
        'Add <b>3 accessories</b> to reach the goal.',
        'Nice! <b>2 more accessories</b> to go.',
        'Almost there! <b>1 more accessory</b>.',
        '<b>GOAL REACHED!</b> Thanks for helping us take back what’s ours.'
      ]
    }
  };
  function idioma() { return window.HUMO_IDIOMA ? window.HUMO_IDIOMA.get() : 'es'; }
  function T() { return TX[idioma()]; }
  function $(sel, base) { return (base || raiz).querySelector(sel); }
  function $$(sel, base) { return Array.prototype.slice.call((base || raiz).querySelectorAll(sel)); }
  function dinero(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function dos(n) { return n < 10 ? '0' + n : '' + n; }
  function decir(t) { var v = $('[data-pv-vivo]'); if (v) v.textContent = t; }
  function suave() { return LENTO ? 'auto' : 'smooth'; }

  /* ======================================================================
     PASOS
     ====================================================================== */
  var pasos = { 1: $('[data-pv-paso="1"]'), 2: $('[data-pv-paso="2"]'), 3: $('[data-pv-paso="3"]') };

  function abrir(n, bajar) {
    if (pasos[n].classList.contains('is-bloqueado')) return;
    [1, 2, 3].forEach(function (k) { pasos[k].classList.toggle('is-abierto', k === n); });
    if (bajar) setTimeout(function () {
      var y = pasos[n].getBoundingClientRect().top + window.scrollY - (($('.pv__urg') || {}).offsetHeight || 0) - 12;
      window.scrollTo({ top: y, behavior: suave() });
    }, LENTO ? 0 : 320);
    if (n === 2) puntosAcc();
  }

  /* ======================================================================
     URGENCIA
     ====================================================================== */
  var cierre = Date.parse(raiz.getAttribute('data-cierre'));
  var inicio = Date.parse(raiz.getAttribute('data-inicio'));
  function reloj() {
    var r = cierre - Date.now();
    var barra = $('[data-pv-urg-barra]');
    if (!cierre || r <= 0) {
      $('.pv__urg-txt').textContent = T().fin;
      $('.pv__urg-reloj').hidden = true;
      if (barra) barra.style.width = '100%';
      $('[data-pv-aviso]').textContent = '';
      var rj = $('.pvp__reloj'); if (rj) rj.hidden = true;
      return false;
    }
    var t = Math.floor(r / 1000);
    var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
    $('[data-pv-u="d"]').textContent = dos(d);
    $('[data-pv-u="h"]').textContent = dos(h);
    $('[data-pv-u="m"]').textContent = dos(m);
    $('[data-pv-u="s"]').textContent = dos(s);
    $('[data-pv-c="d"]').textContent = dos(d);
    $('[data-pv-c="h"]').textContent = dos(h);
    $('[data-pv-c="m"]').textContent = dos(m);
    $('[data-pv-c="s"]').textContent = dos(s);
    if (barra && inicio && cierre > inicio) barra.style.width = Math.min(100, Math.max(0, (Date.now() - inicio) / (cierre - inicio) * 100)).toFixed(1) + '%';
    $('[data-pv-aviso]').textContent = T().aviso(d + 'd ' + dos(h) + 'h ' + dos(m) + 'm');
    return true;
  }
  if (reloj()) { var idReloj = setInterval(function () { if (!reloj()) clearInterval(idReloj); }, 1000); }

  /* ======================================================================
     PASO 1: BARRILES
     ====================================================================== */
  var pista = $('[data-pv-pista]');
  var tallas = $$('[data-pv-talla]');
  var destacado = Math.max(0, Math.min(BARRILES.length - 1, (parseInt(raiz.getAttribute('data-destacado'), 10) || 2) - 1));
  var actual = destacado;

  /* etiqueta de cada barril: entra deslizando al cambiar de tamaño */
  var ICONOS = [
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/><circle cx="7.5" cy="8.5" r="1.6" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 18h18l-1.5-9-4.5 4-3-7-3 7-4.5-4z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  ];
  var badge = $('[data-pv-badge-in]');
  var badgeIdx = -1;
  function etiquetas() { return (raiz.getAttribute('data-badges-' + idioma()) || '').split(','); }
  function pintarBadge(i, dir) {
    var txt = (etiquetas()[i] || '').trim();
    $('[data-pv-badge]').hidden = !txt;
    var html = (ICONOS[i] || ICONOS[1]) + '<span>' + txt + '</span>';
    if (badgeIdx === -1 || LENTO || !dir) { badge.innerHTML = html; badge.className = 'pv__badge-in'; badgeIdx = i; return; }
    badgeIdx = i;
    badge.className = 'pv__badge-in ' + (dir > 0 ? 'sale-izq' : 'sale-der');
    setTimeout(function () {
      badge.innerHTML = html;
      badge.className = 'pv__badge-in ' + (dir > 0 ? 'entra-der' : 'entra-izq');
    }, 200);
  }

  function irBarril(i, animar) {
    i = (i + BARRILES.length) % BARRILES.length;
    pista.scrollTo({ left: i * pista.clientWidth, behavior: animar === false ? 'auto' : suave() });
    pintarBarril(i);
  }

  function pintarBarril(i) {
    var dir = i === actual ? 0 : (i > actual ? 1 : -1);
    actual = i;
    var b = BARRILES[i]; if (!b) return;
    var en = idioma() === 'en';
    $('[data-pv-nombre]').textContent = en ? b.en : b.es;
    var gente = b.gente || '';
    if (!en) gente = gente.replace(/serves/i, 'Para').replace(/\bto\b/i, 'a').replace(/people/i, 'personas');
    $('[data-pv-gente]').textContent = gente ? (en ? 'SERVES ' + gente.replace(/^serves\s*/i, '') : 'PARA ' + gente.replace(/^para\s*/i, '')) : '';
    pintarBadge(i, dir);
    var q = $('[data-pv-quedan]');
    q.hidden = !(b.stock > 0);
    if (b.stock > 0) $('[data-pv-quedan-txt]').innerHTML = T().quedan(b.stock);

    var hayAntes = b.antes > b.precio;
    var hayEquipo = b.equipo > b.antes && hayAntes;
    $('[data-pv-col-equipo]').classList.toggle('is-oculta', !hayEquipo);
    $('[data-pv-col-antes]').classList.toggle('is-oculta', !hayAntes);
    if (hayEquipo) $('[data-pv-equipo]').textContent = dinero(b.equipo);
    if (hayAntes) $('[data-pv-antes]').textContent = dinero(b.antes);
    $('[data-pv-precio]').textContent = dinero(b.precio);
    $('[data-pv-pie]').hidden = !hayAntes;
    $('[data-pv-pie]').disabled = !b.hay;
    if (hayAntes) {
      $('[data-pv-ahorro-monto]').textContent = dinero(b.antes - b.precio);
      $('[data-pv-ahorro-pct]').textContent = Math.round((b.antes - b.precio) / b.antes * 100) + '%';
    }

    var cta = $('[data-pv-elegir]');
    cta.textContent = b.hay ? T().elegir(b.corto) : T().agotado;
    cta.disabled = !b.hay;
    tallas.forEach(function (t, k) { t.setAttribute('aria-selected', String(k === i)); });
  }

  var esperaScroll = null;
  pista.addEventListener('scroll', function () {
    clearTimeout(esperaScroll);
    esperaScroll = setTimeout(function () {
      var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
      if (i !== actual) pintarBarril(i);
    }, 80);
  }, { passive: true });
  window.addEventListener('resize', function () { irBarril(actual, false); }, { passive: true });

  /* ======================================================================
     PASO 2: ACCESORIOS
     ====================================================================== */
  var acc = $('[data-pv-acc]');
  var puntosCaja = $('[data-pv-puntos]');
  function paginasAcc() { return Math.max(1, Math.ceil((acc.scrollWidth - 2) / Math.max(1, acc.clientWidth))); }
  function puntosAcc() {
    var n = paginasAcc();
    if (puntosCaja.children.length !== n) puntosCaja.innerHTML = new Array(n + 1).join('<i></i>');
    var p = Math.round(acc.scrollLeft / Math.max(1, acc.clientWidth));
    $$('i', puntosCaja).forEach(function (el, k) { el.classList.toggle('is-on', k === Math.min(p, n - 1)); });
  }
  acc.addEventListener('scroll', function () { requestAnimationFrame(puntosAcc); }, { passive: true });

  /* ======================================================================
     CARRITO
     ====================================================================== */
  var carrito = { items: [], total_price: 0, items_subtotal_price: 0, total_discount: 0 };

  function pedir(url, datos) {
    return fetch(url, {
      method: datos ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: datos ? JSON.stringify(datos) : undefined
    }).then(function (r) { return r.json(); });
  }
  function leer() { return pedir('/cart.js').then(pintarCarrito).catch(function () {}); }
  function agregar(vid, q) { return pedir('/cart/add.js', { items: [{ id: Number(vid), quantity: q }] }).then(leer); }
  function cambiar(key, q) { return pedir('/cart/change.js', { id: key, quantity: q }).then(pintarCarrito); }

  function esBarril(it) { return IDS_BARRIL.indexOf(it.variant_id) !== -1; }

  function pintarCarrito(c) {
    carrito = c || carrito;
    var items = (carrito.items || []).filter(function (it) { return it.quantity > 0; });
    var barriles = items.filter(esBarril), otros = items.filter(function (it) { return !esBarril(it); });
    var tB = barriles.reduce(function (a, it) { return a + it.final_line_price; }, 0);
    var tA = otros.reduce(function (a, it) { return a + it.final_line_price; }, 0);
    var nA = otros.reduce(function (a, it) { return a + it.quantity; }, 0);

    /* estado de los pasos */
    var hayBarril = barriles.length > 0;
    pasos[1].classList.toggle('is-hecho', hayBarril);
    pasos[2].classList.toggle('is-bloqueado', !hayBarril);
    pasos[3].classList.toggle('is-bloqueado', !hayBarril);
    pasos[2].classList.toggle('is-hecho', hayBarril && nA > 0);
    if (hayBarril) {
      var b0 = barriles[0];
      var nB = barriles.reduce(function (a, it) { return a + it.quantity; }, 0);
      var info = BARRILES.filter(function (b) { return b.vid === b0.variant_id; })[0];
      $('[data-pv-resumen-barril]').textContent = (info ? info.corto : b0.product_title) + ' · ' + dinero(tB) + (nB > 1 ? ' (×' + nB + ')' : '');
      var img = $('[data-pv-resumen-img]');
      if (info && info.img) img.src = info.img;
    } else {
      $('[data-pv-resumen-barril]').textContent = '';
    }
    $('[data-pv-resumen-acc]').textContent = hayBarril ? (nA ? T().acc(nA) + ' · ' + dinero(tA) : T().sinAcc) : '';

    /* tarjetas de accesorios */
    $$('[data-pv-tarjeta]').forEach(function (t) {
      var vid = Number(t.getAttribute('data-vid'));
      var q = otros.filter(function (it) { return it.variant_id === vid; }).reduce(function (a, it) { return a + it.quantity; }, 0);
      t.classList.toggle('is-en-carrito', q > 0);
      var lab = $('.pv__agregar span', t);
      if (lab) lab.textContent = q > 0 ? T().enCarrito(q) : T().agregar;
      var ic = $('.pv__agregar svg path', t);
      if (ic) ic.setAttribute('d', q > 0 ? 'M5 12.5l4.5 4.5L19 7.5' : 'M12 5v14M5 12h14');
    });

    /* meta de 3 accesorios: cada unidad llena un tramo */
    var meta = $('[data-pv-meta]');
    if (meta) {
      var nivel = Math.min(3, nA);
      meta.setAttribute('data-nivel', nivel);
      meta.classList.toggle('is-completa', nivel === 3);
      $$('[data-pv-meta-tramo]', meta).forEach(function (el, k) { el.classList.toggle('is-lleno', k < nivel); });
      $$('[data-pv-meta-punto]', meta).forEach(function (el, k) { el.classList.toggle('is-lleno', k < nivel); });
      $('[data-pv-meta-txt]', meta).innerHTML = T().meta[nivel];
    }

    /* totales del paso 2 */
    $('[data-pv-t-barril]').textContent = dinero(tB);
    $('[data-pv-t-acc]').textContent = dinero(tA);
    $('[data-pv-t-total]').textContent = dinero(tB + tA);

    /* paso 3 */
    var lineas = $('[data-pv-lineas]');
    if (!items.length) {
      lineas.innerHTML = '<p class="pv__vacio">' + T().vacio + '</p>';
    } else {
      lineas.innerHTML = items.map(function (it) {
        return '<article class="pv__linea">' +
          (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><p class="pv__linea-nom">' + it.product_title + '</p>' +
            '<div class="pv__cant pv__cant--chica" data-key="' + it.key + '">' +
              '<button type="button" data-pv-linea="-1" aria-label="-">−</button>' +
              '<input type="number" value="' + it.quantity + '" min="0" readonly aria-label="Cantidad">' +
              '<button type="button" data-pv-linea="1" aria-label="+">+</button>' +
            '</div></div>' +
          '<div class="pv__linea-der"><b>' + dinero(it.final_line_price) + '</b>' +
            '<button type="button" class="pv__quitar" data-pv-quitar="' + it.key + '">' + T().quitar + '</button></div>' +
        '</article>';
      }).join('');
    }
    $('[data-pv-sub]').textContent = dinero(carrito.items_subtotal_price || 0);
    $('[data-pv-total]').textContent = dinero(carrito.total_price || 0);
    var dd = carrito.total_discount || 0;
    $('[data-pv-fila-desc]').hidden = dd <= 0;
    if (dd > 0) $('[data-pv-desc]').textContent = '-' + dinero(dd);
    var pagar = $('[data-pv-pagar]');
    pagar.classList.toggle('is-apagado', !items.length);

    /* aviso al resto de la página (contador del encabezado, etc.) */
    document.dispatchEvent(new CustomEvent('humo:carrito-cambio', { detail: carrito }));
    return carrito;
  }

  /* ======================================================================
     FICHA DEL PRODUCTO EN VENTANA
     ====================================================================== */
  var modal = $('[data-pv-modal]');
  var cuerpo = $('[data-pv-modal-cuerpo]');
  function abrirFicha(h) {
    if (!modal || !h) return;
    cuerpo.innerHTML = '<p class="pv__vacio">' + T().cargando + '</p>';
    if (modal.showModal) modal.showModal();
    pedir('/products/' + h + '.js').then(function (p) {
      var v = p.variants[0];
      var fotos = (p.images || []).map(function (src) { return '<img src="' + src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2') + '" alt="" loading="lazy">'; }).join('');
      cuerpo.innerHTML =
        '<div class="pv__ficha">' +
          '<div class="pv__galeria" data-pv-galeria>' + fotos + '</div>' +
          '<div class="pv__galeria-puntos" data-pv-gal-puntos>' + new Array((p.images || []).length + 1).join('<i></i>') + '</div>' +
          '<h3>' + p.title + '</h3>' +
          '<div class="pv__ficha-precio"><b>' + dinero(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + dinero(v.compare_at_price) + '</s>' : '') + '</div>' +
          '<div class="pv__comprar">' +
            '<div class="pv__cant"><button type="button" data-pv-menos aria-label="-">−</button><input type="number" value="1" min="1" inputmode="numeric" aria-label="Cantidad" data-pv-cant><button type="button" data-pv-mas aria-label="+">+</button></div>' +
            '<button type="button" class="pv__cta" data-pv-ficha-agregar="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + (v.available ? T().agregarCarrito : T().agotado) + '</button>' +
          '</div>' +
          '<div class="pv__ficha-desc">' + (p.description || '') + '</div>' +
        '</div>';
      var gal = $('[data-pv-galeria]', cuerpo), pts = $$('i', $('[data-pv-gal-puntos]', cuerpo));
      if (pts[0]) pts[0].classList.add('is-on');
      gal.addEventListener('scroll', function () {
        var k = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        pts.forEach(function (el, j) { el.classList.toggle('is-on', j === k); });
      }, { passive: true });
    }).catch(function () { cuerpo.innerHTML = '<p class="pv__vacio">' + T().error + '</p>'; });
  }
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });

  /* ======================================================================
     CLICS
     ====================================================================== */
  function cantidadDe(el) {
    var c = el && el.querySelector('[data-pv-cant]');
    return Math.max(1, parseInt(c ? c.value : 1, 10) || 1);
  }

  raiz.addEventListener('click', function (ev) {
    var t = ev.target;

    var paso = t.closest('[data-pv-abrir]');
    if (paso) { abrir(Number(paso.getAttribute('data-pv-abrir')), true); return; }

    /* la X de un accesorio agregado lo saca del carrito */
    var qa = t.closest('[data-pv-quitar-acc]');
    if (qa) {
      var vq = Number(qa.getAttribute('data-pv-quitar-acc'));
      qa.disabled = true;
      (carrito.items || []).filter(function (it) { return it.variant_id === vq; })
        .reduce(function (pr, it) { return pr.then(function () { return cambiar(it.key, 0); }); }, Promise.resolve())
        .then(function () { qa.disabled = false; }, function () { qa.disabled = false; });
      return;
    }

    var ir = t.closest('[data-pv-ir]');
    if (ir) { irBarril(actual + Number(ir.getAttribute('data-pv-ir'))); return; }

    var talla = t.closest('[data-pv-talla]');
    if (talla) { irBarril(Number(talla.getAttribute('data-pv-talla'))); return; }

    var accIr = t.closest('[data-pv-acc-ir]');
    if (accIr) { acc.scrollBy({ left: Number(accIr.getAttribute('data-pv-acc-ir')) * acc.clientWidth * .9, behavior: suave() }); return; }

    var menos = t.closest('[data-pv-menos]'), mas = t.closest('[data-pv-mas]');
    if (menos || mas) {
      var campo = (menos || mas).parentNode.querySelector('[data-pv-cant]');
      campo.value = Math.max(1, (parseInt(campo.value, 10) || 1) + (mas ? 1 : -1));
      return;
    }

    /* la franja roja de ahorro también agrega el barril */
    if (t.closest('[data-pv-comprar-ya]')) { $('[data-pv-elegir]').click(); return; }

    var elegir = t.closest('[data-pv-elegir]');
    if (elegir && !elegir.disabled) {
      elegir.disabled = true;
      agregar(BARRILES[actual].vid, cantidadDe($('[data-pv-cant-barril]').parentNode)).then(function () {
        elegir.disabled = false;
        decir(T().okBarril);
        abrir(2, true);
      }).catch(function () { elegir.disabled = false; });
      return;
    }

    var add = t.closest('[data-pv-agregar]');
    if (add && !add.disabled) {
      add.disabled = true;
      var tarjeta = add.closest('[data-pv-tarjeta]');
      agregar(add.getAttribute('data-pv-agregar'), cantidadDe(tarjeta)).then(function () {
        add.disabled = false;
        var c = $('[data-pv-cant]', tarjeta); if (c) c.value = 1;
        decir(T().okAcc);
      }).catch(function () { add.disabled = false; });
      return;
    }

    if (t.closest('[data-pv-ir-carrito]')) { abrir(3, true); return; }

    var linea = t.closest('[data-pv-linea]');
    if (linea) {
      var caja = linea.closest('[data-key]');
      var q = parseInt($('input', caja).value, 10) || 0;
      cambiar(caja.getAttribute('data-key'), Math.max(0, q + Number(linea.getAttribute('data-pv-linea'))));
      return;
    }

    var quitar = t.closest('[data-pv-quitar]');
    if (quitar) { cambiar(quitar.getAttribute('data-pv-quitar'), 0); return; }

    var pdp = t.closest('[data-pv-pdp]');
    if (pdp) { abrirFicha(pdp.getAttribute('data-pv-pdp')); return; }

    if (t.closest('[data-pv-cerrar]')) { modal.close(); return; }

    var fichaAdd = t.closest('[data-pv-ficha-agregar]');
    if (fichaAdd && !fichaAdd.disabled) {
      fichaAdd.disabled = true;
      var vid = Number(fichaAdd.getAttribute('data-pv-ficha-agregar'));
      agregar(vid, cantidadDe(fichaAdd.parentNode)).then(function () {
        modal.close();
        decir(IDS_BARRIL.indexOf(vid) !== -1 ? T().okBarril : T().okAcc);
        if (IDS_BARRIL.indexOf(vid) !== -1 && pasos[1].classList.contains('is-abierto')) abrir(2, true);
      }).catch(function () { fichaAdd.disabled = false; });
      return;
    }

    if (t.closest('[data-pv-aplicar]')) {
      var cod = ($('[data-pv-codigo]').value || '').trim();
      if (!cod) return;
      t.closest('[data-pv-aplicar]').textContent = T().aplicando;
      window.location.href = '/discount/' + encodeURIComponent(cod) + '?redirect=' + encodeURIComponent(window.location.pathname + '#preventa');
      return;
    }
  });

  /* ======================================================================
     OFERTA ESPECIAL ANTES DE PAGAR
     Reglas:
     1. Aparece una vez por carga de página al tocar ASEGURAR MI PREVENTA.
        Si el cliente la cierra, no vuelve hasta que recargue.
     2. Muestra la versión flash de cada accesorio que el cliente NO agregó
        en el paso 2. Si ya agregó el original, su versión flash no aparece.
     ====================================================================== */
  var flash = $('[data-pv-flash]');
  var flashMostrado = false;
  function idsCarrito() { return (carrito.items || []).map(function (it) { return it.variant_id; }); }
  /* deja visibles solo las ofertas cuyo accesorio original no está en el carrito */
  function filtrarFlash() {
    var ids = idsCarrito(), visibles = 0;
    $$('[data-pv-flash-item]', flash).forEach(function (li) {
      var orig = Number(li.getAttribute('data-orig')) || 0;
      var ocultar = orig && ids.indexOf(orig) !== -1;
      li.hidden = ocultar;
      if (!ocultar && ids.indexOf(Number(li.getAttribute('data-vid'))) === -1) visibles++;
    });
    return visibles;
  }
  function pintarFlash() {
    if (!flash) return;
    var ids = idsCarrito();
    $$('[data-pv-flash-item]', flash).forEach(function (li) {
      var en = ids.indexOf(Number(li.getAttribute('data-vid'))) !== -1;
      li.classList.toggle('is-en-carrito', en);
      var lab = $('.pvf__add span', li); if (lab) lab.textContent = en ? T().agregado : T().agregar;
      var ic = $('.pvf__add svg path', li); if (ic) ic.setAttribute('d', en ? 'M5 12.5l4.5 4.5L19 7.5' : 'M12 5v14M5 12h14');
    });
  }
  if (flash) {
    $('[data-pv-pagar]').addEventListener('click', function (ev) {
      /* una vez por carga de página */
      if (flashMostrado || !flash.showModal) return;
      if (filtrarFlash() === 0) return;
      ev.preventDefault();
      flashMostrado = true;
      pintarFlash();
      flash.showModal();
    });
    flash.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t === flash || t.closest('[data-pv-flash-cerrar]')) { flash.close(); return; }
      var b = t.closest('[data-pv-flash-add]');
      if (b && !b.disabled) {
        var vid = Number(b.getAttribute('data-pv-flash-add'));
        var linea = (carrito.items || []).filter(function (it) { return it.variant_id === vid; })[0];
        b.disabled = true;
        (linea ? cambiar(linea.key, 0) : agregar(vid, cantidadDe(b.closest('[data-pv-flash-item]')))).then(function () { b.disabled = false; pintarFlash(); })
          .catch(function () { b.disabled = false; });
      }
    });
  }

  /* gestos de deslizar sobre la foto del barril en escritorio con mouse */
  var arrastre = null;
  pista.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') arrastre = e.clientX; });
  window.addEventListener('pointerup', function (e) {
    if (arrastre === null) return;
    var dx = e.clientX - arrastre; arrastre = null;
    if (Math.abs(dx) > 50) irBarril(actual + (dx < 0 ? 1 : -1));
  });

  /* ---------- idioma ---------- */
  document.addEventListener('humo:idioma', function () { badgeIdx = -1; pintarBarril(actual); pintarCarrito(); pintarFlash(); reloj(); });

  /* ---------- arranque ---------- */
  requestAnimationFrame(function () { irBarril(destacado, false); });
  /* siempre arranca en el paso 1, aunque el carrito ya tenga un barril */
  leer().then(function () { puntosAcc(); });
})();
